import { createContext, FC } from 'react';
import { useGuide } from 'hooks/useGuide';
import { useMediaQuery } from '@chakra-ui/react';
import { MobileNavigationContainer, NavigationContainer } from '.';
export type GuideContextType = ReturnType<typeof useGuide>;
export const GuideContext = createContext({} as GuideContextType);
export const GuideContainer: FC = () => {
  const [isMobile] = useMediaQuery(['(max-width: 900px)']);
  const hookReturn = useGuide();
  return <>
      <GuideContext.Provider value={{
      ...hookReturn
    }} data-sentry-element="unknown" data-sentry-source-file="GuideContainer.tsx">
        {isMobile ? <MobileNavigationContainer /> : <NavigationContainer />}
      </GuideContext.Provider>
    </>;
};